import React from "react"
import { FaSearch } from "react-icons/fa"

const InsightsCardHeading: React.FC<{ heading: string; enable: boolean }> = ({
  heading,
  enable,
}) => {
  return (
    <div
      className={`flex items-center justify-between px-4 py-4 ${
        enable ? "bg-site-blue" : "bg-gray-700"
      }`}
      style={{ borderTopLeftRadius: "27px", borderTopRightRadius: "27px" }}
    >
      <h1 className="flex items-center text-blue-100">
        <span>
          <FaSearch className="mr-2" />
        </span>
        <span>{heading}</span>
      </h1>
    </div>
  )
}

export default InsightsCardHeading
